const eye = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="46.5" cy="46.5" r="46.5" />
      <g clipPath="url(#clip0_127_3138)">
        <path
          d="M7 46.396C13.9153 34.9788 23.4518 26.9477 36.6467 23.8462C45.3035 21.8162 53.7987 22.7 61.9752 26.2192C62.5685 26.4735 62.8913 26.3887 63.3211 25.9528C65.6861 23.5475 68.0813 21.1725 70.4665 18.7873C71.1646 18.0912 71.9879 17.8268 72.9505 18.1174C73.3675 18.229 73.7444 18.4566 74.0372 18.7738C74.3301 19.0909 74.527 19.4847 74.6051 19.9093C74.8231 20.8859 74.4356 21.6608 73.7455 22.3489C70.4792 25.5964 67.2204 28.8519 63.9689 32.1155C49.6917 46.39 35.4178 60.6671 21.1474 74.947C20.4512 75.6432 19.7046 76.1477 18.6835 75.956C18.2432 75.8943 17.8303 75.7061 17.495 75.4141C17.1597 75.1222 16.9164 74.7391 16.7948 74.3114C16.4901 73.3549 16.7343 72.5215 17.4325 71.8213C19.4396 69.8034 21.4507 67.7923 23.4659 65.7879C23.6677 65.5861 23.8937 65.4327 24.1944 65.1825C17.0127 60.6221 11.2073 54.8873 7 47.6047V46.396ZM58.8717 30.2368C58.7782 30.182 58.6819 30.1321 58.5831 30.0875C50.334 26.9658 42.0143 26.7923 33.7067 29.7303C24.7513 32.8984 17.9672 38.8633 12.5532 46.5413C12.2647 46.9449 12.3877 47.1971 12.6178 47.526C14.918 50.8373 17.625 53.8467 20.6752 56.4834C22.8152 58.3631 25.1434 60.0171 27.6228 61.4191L33.7551 55.2908C29.3561 48.7811 31.0713 41.3291 35.1676 37.0008C39.2014 32.7228 47.0429 30.3781 54.0167 35.11L58.8717 30.2368ZM37.3268 51.7111C41.6854 47.3552 46.0333 43.0093 50.3704 38.6736C47.4444 36.688 42.428 36.694 38.931 40.0861C35.7488 43.1593 35.0486 48.315 37.3268 51.7111Z"
          fill="black"
        />
        <path
          d="M33.5898 69.2961C34.8752 68.0228 36.0961 66.7939 37.3471 65.5973C37.4473 65.5315 37.5597 65.4867 37.6776 65.4656C37.7955 65.4444 37.9165 65.4474 38.0332 65.4742C50.1546 67.9986 60.7606 64.78 70.1478 56.9991C73.3875 54.2739 76.2504 51.1301 78.6613 47.6502C79.0205 47.1417 78.9761 46.8269 78.6391 46.3507C75.8009 42.3067 72.3681 38.7147 68.4568 35.6963C68.2429 35.5308 68.0311 35.3593 67.8515 35.212L71.3707 31.6646C72.533 32.6614 73.7598 33.6562 74.9201 34.7196C78.2788 37.8043 81.2171 41.3173 83.6596 45.1682C84.4667 46.4233 84.4909 47.5413 83.6757 48.8004C77.505 58.3147 69.4073 65.4681 58.5309 69.1084C50.4856 71.8023 42.3353 71.8547 34.177 69.512C34.0116 69.4615 33.8542 69.3929 33.5898 69.2961Z"
          fill="black"
        />
        <path
          d="M59.6904 43.2202C60.9253 49.0115 59.5935 53.8706 55.3519 57.749C51.5644 61.2036 47.0645 62.1883 41.8906 61.0119C43.4 59.5126 44.7762 58.1263 46.1806 56.7743C46.3853 56.6321 46.6276 56.5541 46.8768 56.5503C48.9904 56.2826 50.955 55.3197 52.4615 53.8132C53.9679 52.3068 54.9308 50.3422 55.1986 48.2286C55.2268 47.9885 55.2611 47.6858 55.4125 47.5304C56.7745 46.128 58.1628 44.7518 59.6904 43.2202Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3138">
          <rect
            width="77.2728"
            height="58"
            fill="white"
            transform="translate(7 18)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default eye;
